import { Component, Input, ViewChild, OnInit, Renderer2, Inject, OnDestroy } from '@angular/core';
import { CalendarItemEnum } from 'src/app/models/enums/calendarItemType';
import { IconService } from 'src/app/shared/services/icon.service';
import { ExamsCalendarComponent } from '../../exams-calendar/exams-calendar.component';
import { DOCUMENT } from '@angular/common';
import { FullscreenComponent } from 'src/app/shared/additional-styles/fullscreen-component';

@Component({
  selector: 'app-exams-and-tasks-calendar-block-list',
  templateUrl: './exams-and-tasks-calendar-block-list.component.html',
  styleUrls: ['./exams-and-tasks-calendar-block-list.component.scss'],
})
export class ExamsAndTasksCalendarBlockListComponent extends FullscreenComponent implements OnInit, OnDestroy {
  constructor(
    private iconService: IconService,
    renderer: Renderer2, 
    @Inject(DOCUMENT) document: Document
  ) {
    super(renderer, document);
  }

  showShareBtn: boolean = true;

  @ViewChild(ExamsCalendarComponent) calendarComponent!: ExamsCalendarComponent;
  blockData: any;
  @Input() set pageData(value: any) {
    if (value) {
      if(value.icon) {
        this.iconService.addIconToRegistry({
          key: value.icon,
          path: value.icon,
        });
      } else {
        value.icon = 'calendar';
      }  
      this.blockData = value;
    }
  }

  ngOnInit(): void {
    super.setAddithonalStyles();
  }

  ngOnDestroy(): void {
    super.setAddithonalStyles(true);
  }

  printBtnClick() {
    window.print(); //TODO: print
  }

  addToCalendarClick(type: CalendarItemEnum) {
    this.calendarComponent.addToCalendarEvent(type);
  }

  serverErrorAppeared() {
    this.showShareBtn = false;
  }
}
